export const cleanObject = (obj: Record<string, any>): Record<string, any> => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0),
    ),
  );
};

export const getObjectDifferences = (
  input1: Record<string, any>,
  input2: Record<string, any>,
): string[] => {
  const changes: string[] = [];

  // Get all unique keys from both objects
  const keys = new Set([...Object.keys(input1)]);

  for (const key of keys) {
    const val1 = input1[key];
    const val2 = input2[key];

    if (val1 !== val2 && val2 !== undefined && key !== "availability") {
      changes.push(
        `${key} changed from ${JSON.stringify(val1)} to ${JSON.stringify(
          val2,
        )}`,
      );
    }
  }

  return changes;
};

export const listsAreEqual = (list1: any, list2: any) => {
  if (list1.length !== list2.length) {
    return false;
  }
  let count = 0;
  for (let i = 0; i < list1.length; i++) {
    for (let t = 0; t < list2.length; t++) {
      if (list1[i] === list2[t]) {
        count = count + 1;
      }
    }
  }
  if (list1.length !== count) {
    return false;
  } else {
    return true;
  }
};

export const areObjectArraysEqual = (arr1: any[], arr2: any[]): boolean => {
  if (arr1.length !== arr2.length) return false;

  const sorted1 = [...arr1].sort((a, b) => a.minuteOfWeek - b.minuteOfWeek);
  const sorted2 = [...arr2].sort((a, b) => a.minuteOfWeek - b.minuteOfWeek);

  for (let i = 0; i < sorted1.length; i++) {
    if (!isDeepEqualObject(sorted1[i], sorted2[i])) {
      return false;
    }
  }

  return true;
};

// You can use your existing isDeepEqualObject function:
export const isDeepEqualObject = (obj1: any, obj2: any): boolean => {
  if (obj1 === obj2) return true;

  if (
    typeof obj1 !== "object" ||
    obj1 === null ||
    typeof obj2 !== "object" ||
    obj2 === null
  ) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (const key of keys1) {
    if (!keys2.includes(key)) return false;
    if (!isDeepEqualObject(obj1[key], obj2[key])) return false;
  }

  return true;
};
